import { GLOBAL_ADMIN_EMAIL_DOMAINS } from "@signalist/shared-types";

/**
 * The e-mail domains of Signalist's own accounts inside customer companies (story AC, PREC-3940).
 * The same list that may hold the global Admin role (PREC-4636), from one place.
 */
export const SUPPORT_USER_DOMAINS: readonly string[] = GLOBAL_ADMIN_EMAIL_DOMAINS;

export interface SupportUserCandidate {
	id: number;
	email: string;
}

const domainOf = (email: string): string => email.trim().toLowerCase().split("@")[1] ?? "";

/**
 * The dedicated support user of a customer company: the user whose e-mail domain is one of ours
 * (the lowest id when several, so the choice is stable). "Log in as" logs in as this account,
 * never as the customer (decision 3); null when the company has none, which disables the button.
 */
export const pickSupportUser = <T extends SupportUserCandidate>(
	users: readonly T[],
	domains: readonly string[] = SUPPORT_USER_DOMAINS
): T | null =>
	users.filter((user) => domains.includes(domainOf(user.email))).sort((a, b) => a.id - b.id)[0] ??
	null;
